import React, { ReactNode } from "react";
import * as styles from "./popup-sheet-table-header.module.scss";
import { classArr } from "../../helper/style-helper";

export interface PopupSheetTableHeaderProps {
	style?: React.CSSProperties;
	className?: string;
	children?: ReactNode;
}

/**
 * A wrapper component for full-width table headers in popup sheets
 */
export default function PopupSheetTableHeader(
	props: PopupSheetTableHeaderProps,
) {
	return (
		<div
			style={props.style}
			className={classArr(styles.header, props.className)}
		>
			{props.children}
		</div>
	);
}
